import _slicedToArray from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import NoData from '@/components/NoData/NoData';
import delDialog from '@/components/System/DelDialog';
import { valsubstr32addbr, saveFile } from '@/utils/index';
export default {
  components: {
    SearchForm: SearchForm,
    NoData: NoData,
    delDialog: delDialog
  },
  data: function data() {
    return {
      showLoading: false,
      multipleSelection: [],
      delChecked: false,
      // 删除权限
      searchFormData: [{
        title: '系统名称',
        key: '',
        placeholder: '请选择系统名称',
        type: 'select',
        selectData: [],
        selectedArr: [],
        value: '',
        multiple: true
      }, {
        title: '角色名称',
        key: 'role',
        placeholder: '请输入角色名称',
        type: 'input',
        value: null,
        selectData: [],
        selectedArr: []
      }],
      tableData: [],
      btnType: 'add,export,search,reset',
      specificUserForm: {
        roleName: '',
        roleId: null,
        userId: null,
        corner: 'A',
        roleDep: [],
        tel: null
      },
      currentPage: 1,
      pageNum: 1,
      pageSize: 10,
      roleName: '',
      systemId: '',
      loading: false,
      total: 0,
      searchObj: {},
      ifShowDelDialog: false,
      OrgSelectList: [],
      isIndeterminate: false,
      tableheight: 580
    };
  },
  created: function created() {
    var _this = this;
    this.searchForm(this.searchFormData);
    this.$API.getRequest({
      url: '/platform/systemInner/list'
    }).then(function (res) {
      if (res.code === '0000000000') {
        // eslint-disable-next-line array-callback-return
        res.result.records.filter(function (item) {
          var selectvalue = {
            value: item.systemId,
            label: item.systemName
          };
          _this.searchFormData[0].selectData.push(selectvalue);
          _this.specificUserForm.roleName = selectvalue;
        });
      }
    });
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 332;
      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 332;
      };
    });
  },
  methods: {
    delSelect: function delSelect() {
      if (this.multipleSelection.length > 0) {
        this.ifShowDelDialog = true;
      } else {
        this.$message({
          message: '请选择要删除的角色',
          type: 'warning'
        });
      }
    },
    selectAll: function selectAll(checked) {
      var _this2 = this;
      if (checked) {
        this.tableData.forEach(function (ele) {
          _this2.$refs.multipleTable.toggleRowSelection(ele, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      this.isIndeterminate = false;
    },
    currentChange: function currentChange(page) {
      this.pageNum = page;
      this.searchList(this.searchObj);
    },
    sizeChange: function sizeChange(size) {
      this.pageSize = size;
      this.searchList(this.searchObj);
    },
    getChangeSelect: function getChangeSelect(item) {
      this.searchFormData.selectedArr = item.selectedArr;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var checkedCount = val.length;
      this.delChecked = checkedCount === this.tableData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
      this.multipleSelection = val;
    },
    searchForm: function searchForm(obj) {
      this.pageNum = 1;
      this.pageSize = 10;
      this.searchObj = obj;
      this.searchList(obj);
    },
    resetForm: function resetForm(obj) {
      var _obj = _slicedToArray(obj, 2),
        systemObj = _obj[0],
        roleObj = _obj[1];
      systemObj.selectedArr = [];
      roleObj.value = '';
      this.searchObj = [systemObj, roleObj];
      this.searchList(this.searchObj);
    },
    searchList: function searchList(obj) {
      var _this3 = this;
      var systemIds = [];
      var roleName = '';
      this.showLoading = true;
      if (obj[0].selectedArr) {
        systemIds = obj[0].selectedArr;
      }
      roleName = obj[1].value || '';
      this.$API.postRequest({
        url: '/platform/roleInner/list',
        data: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          roleName: roleName,
          systemIds: systemIds
        }
      }).then(function (res) {
        _this3.showLoading = false;
        if (res.code === '0000000000') {
          _this3.tableData = res.result.records;
          _this3.total = res.result.total;
          // this.showLoading = false
        }
      });
    },
    exportTable: function exportTable(obj) {
      var _this4 = this;
      var systemId = '';
      if (obj[0].selectedArr) {
        systemId = obj[0].selectedArr;
      }
      var roleName = obj[1].value || '';
      var data = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        systemId: systemId,
        roleName: roleName
      };
      this.$API.postRequest({
        url: '/platform/roleInner/list/export',
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          var value = res.result.filePath;
          return value;
        }
      }).then(function (res) {
        _this4.$API.getRequest({
          url: '/platform/file/templateDownload',
          data: {
            filePath: res
          },
          responseType: 'blob'
        }).then(function (res) {
          saveFile(res.data, '角色列表导出文件.xlsx');
        });
      });
    },
    addRole: function addRole() {
      this.$router.push({
        path: '/system/role/edit'
      });
    },
    editRoleDialog: function editRoleDialog(item) {
      var _item$row, _item$row2;
      // this.$router.push({
      //   path: '/system/role/edit',
      //   query: {
      //     roleId: item?.row?.roleId,
      //     systemId: item?.row?.systemId,
      //   },
      // });
      window.open(decodeURIComponent("".concat(window.location.origin, "/system/role/edit?roleId=").concat(item === null || item === void 0 ? void 0 : (_item$row = item.row) === null || _item$row === void 0 ? void 0 : _item$row.roleId, "&systemId=").concat(item === null || item === void 0 ? void 0 : (_item$row2 = item.row) === null || _item$row2 === void 0 ? void 0 : _item$row2.systemId)));
    },
    checkRoleDetail: function checkRoleDetail(item) {
      var _item$row3, _item$row4;
      // this.$router.push({
      //   path: `/system/role/detail/${item?.row?.roleId}/${item?.row?.systemId}`,
      // });
      window.open(decodeURIComponent("".concat(window.location.origin, "/system/role/detail/").concat(item === null || item === void 0 ? void 0 : (_item$row3 = item.row) === null || _item$row3 === void 0 ? void 0 : _item$row3.roleId, "/").concat(item === null || item === void 0 ? void 0 : (_item$row4 = item.row) === null || _item$row4 === void 0 ? void 0 : _item$row4.systemId)));
    },
    delRole: function delRole() {
      var _this5 = this;
      this.ifShowDelDialog = false;
      var systemId = '';
      var roleIdList = [];
      if (this.delChecked) {
        this.tableData.forEach(function (ele) {
          roleIdList.push(ele.roleId);
          systemId = ele.systemId;
        });
      } else {
        this.multipleSelection.forEach(function (ele) {
          roleIdList.push(ele.roleId);
          systemId = ele.systemId;
        });
      }
      if (this.pageNum === Math.ceil(this.total / this.pageSize) && (this.total % this.pageSize === roleIdList.length || this.total % this.pageSize === 0)) {
        this.pageNum > 1 ? this.pageNum-- : this.pageNum = 1;
      }
      this.$API.delRequest({
        url: '/platform/roleInner',
        data: {
          roleIdList: roleIdList,
          systemId: systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.$message({
            message: '删除角色成功',
            type: 'success'
          });
          if (_this5.pageNum === Math.ceil(_this5.total / _this5.pageSize) && _this5.delChecked) {
            _this5.pageNum -= 1;
            _this5.delChecked = false;
          }
          _this5.searchList(_this5.searchObj);
        }
      });
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};